import { fetchV3WithTranslateServerErrors } from './base';

import { EVENT_DEFAULT_ERROR_MESSAGE } from '../constants';

import { _getTaxPolicies } from './constants';

/**
 * How to handle errors on the event lifecycle
 */
const ERROR_SPEC = {
    default: () => EVENT_DEFAULT_ERROR_MESSAGE,
};

/**
 * Return a `fetch` Promise to get Tax Policies settings for a specific country
 *
 * @param {string} country
 */
export const fetchTaxPolicies = (country = 'US') =>
    fetchV3WithTranslateServerErrors(ERROR_SPEC, _getTaxPolicies(country), {
        method: 'GET',
    });
